import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import './lottery_styles/lotteryparticipate.css';

export default function LotteryParticipate() {
  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
          <Col>
            <div className="participate">
              <div className="part_head d-flex justify-content-center mb-3">
                <h2>How to Participate?</h2>
              </div>
               <div className="">
              <Row className='part_content'>
                <Col lg={4} className='lot_par_col'>
                 <div className="part_content1">
                  <div className="part_content1_1 mb-3">
                    <span>1</span>
                  </div>
                  <div className="part_content1_1c">
                    <p className='fw-bold'>INVITE</p>
                    <span>Set how much refferal commission you want to share with your friends.</span>
                  </div>
                 </div>
                </Col>
                <Col lg={4} className='lot_par_col'>
                <div className="part_content2">
                  <div className="part_content2_2 mb-3">
                    <span>2</span>
                  </div>
                  <div className="part_content2_2c">
                    <p className='fw-bold'>COMPLETE TASKS</p>
                    <span>Set how much refferal commission you want to share with your friends.</span>
                  </div>
                </div>
                </Col>
                <Col lg={4} className='lot_par_col'>
                <div className="part_content3 ">
                  <div className="part_content3_3 mb-3">
                    <span>3</span>
                  </div>
                  <div className="part_content1_1c">
                    <p className='fw-bold'>RECEIVE MYSTERY BOX</p>
                    <span>Set how much refferal commission you want to share with your friends.</span>
                  </div>
                </div>
                </Col>
              </Row>
               </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
